var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.2 21.4",
    style: {
      enableBackground: "new 0 0 28.2 21.4"
    },
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:current;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.7,0c-3.8,0-6.9,2.8-7.4,6.5l-12.4,0c0,0,0,0,0,0c-0.1,0-0.2,0-0.3,0.1c0,0-0.1,0-0.1,0.1 c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0s0,0,0,0v13.5 c0,0.4,0.3,0.8,0.8,0.8H21c0.4,0,0.8-0.3,0.8-0.8v-5.8c3.6-0.5,6.4-3.6,6.4-7.4C28.2,3.4,24.8,0,20.7,0z M13.2,8 c0.1,1.3,0.5,2.5,1.2,3.5l-3.4,2.6L2.5,8L13.2,8z M20.3,19.9H1.6V9.2l8.9,6.5c0.1,0.1,0.3,0.1,0.4,0.1c0.2,0,0.3-0.1,0.5-0.2l3.9-3 c1.3,1.3,3,2.2,5,2.3V19.9z M25.1,4.7l-4.6,6.4c-0.1,0.2-0.3,0.3-0.5,0.3c0,0-0.1,0-0.1,0c-0.2,0-0.3-0.1-0.4-0.1l-3-2.2 c-0.3-0.2-0.4-0.7-0.2-1c0.2-0.3,0.7-0.4,1-0.2l2.4,1.8l4.1-5.8c0.2-0.3,0.7-0.4,1-0.2C25.2,3.9,25.3,4.4,25.1,4.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailActive);
export default __webpack_public_path__ + "static/media/mail_active.c75f422b2f05c406864f3f50aace20fe.svg";
export { ForwardRef as ReactComponent };